import script from "./DetailSummary.vue?vue&type=script&setup=true&lang=ts"
export * from "./DetailSummary.vue?vue&type=script&setup=true&lang=ts"

import "./DetailSummary.vue?vue&type=style&index=0&id=2f15beab&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2f15beab"]])

export default __exports__